import { render } from "./Making.vue?vue&type=template&id=6273aa82"
import script from "./Making.vue?vue&type=script&lang=js"
export * from "./Making.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jack/Develop/Inncom/LCY/2110.lcy.app.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__